import { useEffect, useRef } from "react";

const WaveformTimeline = ({ peaks, duration, currentTime, onSeek }) => {
  const canvasRef = useRef(null);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const wrapper = wrapperRef.current;
    if (!canvas || !wrapper || !peaks?.length) return undefined;

    const paint = () => {
      const width = Math.max(1, wrapper.clientWidth);
      const height = Math.max(1, wrapper.clientHeight);
      const scale = window.devicePixelRatio || 1;
      canvas.width = Math.round(width * scale);
      canvas.height = Math.round(height * scale);
      const context = canvas.getContext("2d");
      if (!context) return;
      context.scale(scale, scale);
      context.clearRect(0, 0, width, height);
      const bars = Math.max(1, Math.floor(width / 3));
      const step = width / bars;
      const played = duration > 0 ? Math.min(1, Math.max(0, currentTime / duration)) : 0;
      for (let index = 0; index < bars; index += 1) {
        const start = Math.floor(index * peaks.length / bars);
        const end = Math.max(start + 1, Math.ceil((index + 1) * peaks.length / bars));
        let peak = 0;
        for (let item = start; item < end; item += 1) peak = Math.max(peak, peaks[item] || 0);
        const amplitude = Math.max(3, peak * (height - 26));
        context.fillStyle = index / bars <= played ? "#34e0a1" : "#2dd8ec";
        context.globalAlpha = index / bars <= played ? 0.96 : 0.72;
        context.fillRect(index * step, (height - amplitude) / 2, Math.max(1, step - 1.2), amplitude);
      }
      context.globalAlpha = 1;
      const x = Math.min(width - 1, played * width);
      context.fillStyle = "#f0a63d";
      context.fillRect(x, 0, 2, height);
    };

    paint();
    const observer = typeof ResizeObserver !== "undefined" ? new ResizeObserver(paint) : null;
    observer?.observe(wrapper);
    return () => observer?.disconnect();
  }, [peaks, duration, currentTime]);

  return (
    <div ref={wrapperRef} className="relative h-36 w-full overflow-hidden rounded-md border border-border bg-ink/80 sm:h-44 focus-within:ring-2 focus-within:ring-signal">
      <canvas ref={canvasRef} aria-hidden="true" className="block h-full w-full" />
      <input
        type="range"
        min="0"
        max={Math.max(0.01, duration || 0.01)}
        step="0.1"
        value={Math.min(currentTime, duration || 0)}
        onChange={(event) => onSeek(Number(event.target.value))}
        aria-label="Buscar posición en el audio"
        className="absolute inset-0 h-full w-full cursor-crosshair opacity-0"
        data-testid="waveform-seek"
      />
    </div>
  );
};

export default WaveformTimeline;
